// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteDrawerContainer-module_drawer_background_alEsY {
  overflow-y: auto;
  padding: 24px;
  height: 100%;
}

.SiteDrawerContainer-module_width_resize_bar_S46UD {
  width: 4px;
  cursor: col-resize;
  padding: 1px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 15;
  border-left: 1px solid var(--uu-utah-red);
  /* background-color: var(--uu-utah-red); */
}

.SiteDrawerContainer-module_width_resize_bar_S46UD:hover {
  border-left: 2px solid var(--uu-utah-red-hover);
  /* background-color: var(--uu-utah-red-hover); */
}

.SiteDrawerContainer-module_drawer_button_text_u6h6B {
  cursor: pointer;
  color: var(--primary-bos-color);
}

.SiteDrawerContainer-module_drawer_button_text_u6h6B:hover {
  color: var(--primary-button-hover-color);
}

.SiteDrawerContainer-module_no_wrap_drawer_button_text_CXd5C {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SiteDrawerContainer-module_inactive_WuC8I {
}
`, "",{"version":3,"sources":["webpack://./src/client/components/SiteDrawerContainer/SiteDrawerContainer.module.css"],"names":[],"mappings":"AAAA;EAEE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;AAEA","sourcesContent":[".drawer_background {\n  composes: secondary_background from 'Styles/colors.module.css';\n  overflow-y: auto;\n  padding: 24px;\n  height: 100%;\n}\n\n.width_resize_bar {\n  width: 4px;\n  cursor: col-resize;\n  padding: 1px 0 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 15;\n  border-left: 1px solid var(--uu-utah-red);\n  /* background-color: var(--uu-utah-red); */\n}\n\n.width_resize_bar:hover {\n  border-left: 2px solid var(--uu-utah-red-hover);\n  /* background-color: var(--uu-utah-red-hover); */\n}\n\n.drawer_button_text {\n  cursor: pointer;\n  color: var(--primary-bos-color);\n}\n\n.drawer_button_text:hover {\n  color: var(--primary-button-hover-color);\n}\n\n.no_wrap_drawer_button_text {\n  composes: drawer_button_text;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.inactive {\n  composes: inactive from 'Styles/styles.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer_background": `SiteDrawerContainer-module_drawer_background_alEsY ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondary_background"]}`,
	"width_resize_bar": `SiteDrawerContainer-module_width_resize_bar_S46UD`,
	"drawer_button_text": `SiteDrawerContainer-module_drawer_button_text_u6h6B`,
	"no_wrap_drawer_button_text": `SiteDrawerContainer-module_no_wrap_drawer_button_text_CXd5C SiteDrawerContainer-module_drawer_button_text_u6h6B`,
	"inactive": `SiteDrawerContainer-module_inactive_WuC8I ${___CSS_LOADER_ICSS_IMPORT_1___.locals["inactive"]}`
};
export default ___CSS_LOADER_EXPORT___;
